"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIScoreSchemaV2 = void 0;
const scores_1 = require("../../../../../domain/scores");
const zod_1 = __importDefault(require("zod"));
// Response-only schemas without input validation constraints (e.g. length limits).
// Input constraints are enforced at write time; response schemas must accept any stored value.
const CorrectionData = zod_1.default.object({
    stringValue: zod_1.default.string(),
    dataType: zod_1.default.literal("CORRECTION"),
});
const TextData = zod_1.default.object({
    stringValue: zod_1.default.string(),
    dataType: zod_1.default.literal("TEXT"),
});
/**
 * Foundation schema for scores API v2 i.e. trace, observation AND session scores
 *
 * Must be extended with score data specific schema (numeric, categorical, boolean)
 * @see {@link NumericData}, {@link CategoricalData}, {@link BooleanData}
 */
const ScoreFoundationSchemaV2 = scores_1.ScoreSchemaExclReferencesAndDates.extend({
    // Timestamps
    createdAt: zod_1.default.coerce.date(),
    updatedAt: zod_1.default.coerce.date(),
    timestamp: zod_1.default.coerce.date(),
    // Score references; one of the following must be provided
    traceId: zod_1.default.string().nullish(),
    observationId: zod_1.default.string().nullish(),
    sessionId: zod_1.default.string().nullish(),
    datasetRunId: zod_1.default.string().nullish(),
});
exports.APIScoreSchemaV2 = zod_1.default.discriminatedUnion("dataType", [
    ScoreFoundationSchemaV2.extend(scores_1.NumericData.shape),
    ScoreFoundationSchemaV2.extend(scores_1.CategoricalData.shape),
    ScoreFoundationSchemaV2.extend(scores_1.BooleanData.shape),
    ScoreFoundationSchemaV2.extend(CorrectionData.shape),
    // a numeric value does not make sense for TEXT scores, so we omit the property
    ScoreFoundationSchemaV2.omit({ value: true }).extend(TextData.shape),
]);
